import { Notification } from '@/plugins/notifications'
import {
  CreateChildOwnerApi,
  CreateMotherOwnerApi,
  GetOwnerContextApi,
  ListMyChildrenApi,
} from '@/services/backend/owner'
import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'

export const useOwnersAdminStore = defineStore('ownersAdmin', () => {
  const context = reactive({
    owner_type: null,
    is_allowlisted_creator: false,
    can_create_child: false,
    has_parent: false,
  })
  const children = ref([])
  const isLoadingContext = ref(false)
  const isLoadingChildren = ref(false)

  const canCreateMother = computed(
    () => context.is_allowlisted_creator && context.owner_type !== 'filho',
  )
  const canCreateChild = computed(() => context.can_create_child)
  // Usado pra decidir se o grupo "Administração de Owners" aparece no menu —
  // precisa ser um gate de contexto de tenant de verdade (não bypassável por
  // is_master), já que nem toda owner consegue fazer algo nessa área.
  const canManageOwners = computed(() => canCreateMother.value || canCreateChild.value)

  const FetchOwnerContext = async () => {
    try {
      isLoadingContext.value = true
      const result = await GetOwnerContextApi()
      Object.assign(context, result.data)
    } catch (error) {
      console.log(error)
    } finally {
      isLoadingContext.value = false
    }
  }

  const FetchChildren = async () => {
    try {
      isLoadingChildren.value = true
      const result = await ListMyChildrenApi()
      children.value = result.data
    } catch (error) {
      console.log(error)
      if (error.status != 404) {
        Notification.error(error.response.data.message)
      }
    } finally {
      isLoadingChildren.value = false
    }
  }

  const CreateMotherOwner = async (data) => {
    const result = await CreateMotherOwnerApi(data)
    return result.data
  }

  const CreateChildOwner = async (data) => {
    const result = await CreateChildOwnerApi(data)
    await FetchChildren()
    return result.data
  }

  return {
    context,
    children,
    isLoadingContext,
    isLoadingChildren,
    canCreateMother,
    canCreateChild,
    canManageOwners,
    FetchOwnerContext,
    FetchChildren,
    CreateMotherOwner,
    CreateChildOwner,
  }
})
